import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const ProjectCard = ({ project, index, onClick }) => {
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);

  // Function to get correct image URL
  const getImageUrl = (imagePath) => {
    if (!imagePath) return '/placeholder.jpg';

    if (imagePath.startsWith('https')) return imagePath;

    if (imagePath.startsWith('/uploads')) {
      const baseUrl = process.env.REACT_APP_API_URL || 'https://alafoogarage.com/ahalafoo';
      return `${baseUrl}${imagePath}`;
    }

    return `${process.env.REACT_APP_API_URL || 'https://alafoogarage.com/ahalafoo'}${imagePath}`;
  };

  // Prepare photo list
  const photos =
    project.photos && project.photos.length > 0
      ? project.photos.map((photo) => getImageUrl(photo))
      : [getImageUrl(project.mainPhoto)];

  // Auto slideshow effect
  useEffect(() => {
    if (photos.length <= 1) return; // Skip slideshow if only one photo

    const interval = setInterval(() => {
      setCurrentPhotoIndex((prevIndex) =>
        prevIndex === photos.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // change image every 4 seconds

    return () => clearInterval(interval);
  }, [photos]);

  const mainImage = photos[currentPhotoIndex] || '/placeholder.jpg';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "0px 0px -100px 0px" }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="project-card"
      onClick={onClick}
    >
      <div className="project-image">
        <img
          src={mainImage}
          alt={project.projectName}
          onError={(e) => {
            console.error('Image failed to load:', mainImage);
            e.target.src = '/placeholder.jpg';
          }}
        />
        <div className="project-overlay">
          <span className="view-details">View Details</span>
        </div>
      </div>
      <div className="project-content">
        <span className="project-category">{project.category}</span>
        <h3>{project.projectName}</h3>
        <p>{project.content?.substring(0, 100)}...</p>
        {/* <div className="project-status">
          <span className={project.completed ? 'completed' : 'in-progress'}>
            {project.status}
          </span>
        </div> */}
      </div>
    </motion.div>
  );
};

export default ProjectCard;
